export const MAX_DEC = 6;
